(() => {
  'use strict';

  const protectedImageSelector = '[data-viorra-product-media-protected] img';
  const protectedDetailsSelector = '[data-viorra-product-details-protected]';
  const editableSelector =
    'input, textarea, select, option, [contenteditable="true"], [role="textbox"]';

  const elementFromEvent = (event) =>
    event.target instanceof Element ? event.target : null;

  const elementFromNode = (node) => {
    if (node instanceof Element) return node;
    return node?.parentElement ?? null;
  };

  const isProtectedImageEvent = (event) =>
    elementFromEvent(event)?.closest(protectedImageSelector) !== null;

  const isProtectedDetailsEvent = (event) => {
    const target = elementFromEvent(event);

    return Boolean(
      target?.closest(protectedDetailsSelector) && !target.closest(editableSelector)
    );
  };

  const selectionIncludesProtectedDetails = () => {
    const selection = document.getSelection();

    if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
      return false;
    }

    return Boolean(
      elementFromNode(selection.anchorNode)?.closest(protectedDetailsSelector) ||
        elementFromNode(selection.focusNode)?.closest(protectedDetailsSelector)
    );
  };

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (isProtectedImageEvent(event) || isProtectedDetailsEvent(event)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (isProtectedImageEvent(event)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'copy',
    (event) => {
      if (
        isProtectedImageEvent(event) ||
        isProtectedDetailsEvent(event) ||
        selectionIncludesProtectedDetails()
      ) {
        event.preventDefault();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'selectstart',
    (event) => {
      if (isProtectedDetailsEvent(event)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );
})();
